import React from "react";
import { graphql } from "gatsby";
import Post from "../components/Post";

export default function Sports(props) {
  const data = props.data.allAirtablesports.nodes[0].data;
  const pageContext = props.pageContext;
  return <Post data={data} pageContext={pageContext} />;
}
export const pageQuery = graphql`
  query($slug: String!) {
    allAirtablesports(filter: { data: { Name: { eq: $slug } } }) {
      nodes {
        data {
          Destination
          Name
          Title
          Keywords
          Introduction {
            childMarkdownRemark {
              htmlAst
            }
          }
          SummaryHeading
          Summary {
            childMarkdownRemark {
              htmlAst
            }
          }
          Form
          Description
          P1Heading
          P2Image {
            url
          }
          P3Heading
          P3Image {
            url
          }
          MainImage {
            url
          }
          P1Body {
            childMarkdownRemark {
              htmlAst
            }
          }
          P2Body {
            childMarkdownRemark {
              htmlAst
            }
          }
          P3Body {
            childMarkdownRemark {
              htmlAst
            }
          }
          P1Image {
            url
          }
          P2Heading
        }
      }
    }
  }
`;
